module.exports = __webpack_public_path__ + "img/Go.45fa0f85.png";